import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import $ from 'jquery';

import css from 'css';

import WP from 'WP';

import { msg, safeCssClass, gtmPush } from 'helpers';

import Button from 'partials/formElements/Button';
import CloseIcon from 'images/CloseIcon';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
    setCheckoutVisibility,
    setTermsVisibility,
    setTermsAccepted
} from 'store';

const Wrapper = styled.section`
    position fixed;
    display: block;
    height: auto;
    width: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 50px 50px 80px 50px;
    border-radius: 15px;
    z-index: 99999;
    visibility: ${props => props.visible ? 'unset' : 'hidden'};

    @media(max-width: 767px) {
        width: 95%;
    }
`

const Title = styled.h1`
    text-align: center;
    color: #000000;
    font-size: 26px;
    font-weight: bold;
    padding-bottom: 15px;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    padding: 30px;
`;

const TermsText = styled.div`
    color: #000000;
    font-size: .8em;
    margin-bottom: 30px;

    strong {
        font-weight: bold;
    }

    &:last-child {
        padding-bottom: 0;
        margin-bottom: 0!important;
    }
    p {
        font-family: 'Source Sans Pro', sans-serif; 
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        overflow:hidden;
        margin: 0 0 25px;
    }
    h1 {
        font-family: 'Spectral', serif; 
        font-weight: 700;
        font-size: 64px;
        line-height: 73px;
        margin-bottom: 15px;
    }
    h2 {
        font-family: 'Source Sans Pro', sans-serif;  
        font-weight: 400;
        font-size: 32px;
        line-height: 42px;
        margin-bottom: 15px;
    }
    h3 {
        font-family: 'Source Sans Pro', sans-serif; 
        font-weight: 400;
        font-size: 24px;
        line-height: 34px;
        margin-bottom: 15px;
    }
    h4 {
        font-family: 'Source Sans Pro', sans-serif; 
        font-weight: 400;
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
    h5 {
        font-family: 'Source Sans Pro', sans-serif; 
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 15px;
    }
    h6 {
        font-family: 'Source Sans Pro', sans-serif; 
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 15px;
    }
    strong, b {
        font-family: 'Source Sans Pro', sans-serif; 
        font-weight: 600;
    }
    em {
        font-style: italic;
    }
    blockquote {
        font-family: 'Spectral', serif; 
        font-weight: 700;
        font-size:24px;
        line-height:32px;
        position:relative;
    }
    blockquote:before {
        content: '';
        display: block;
        width:2px;
        height:100%;
        position:absolute;
        left:-24px;
        top:0;
        background: #006CEF;
    }
    blockquote p {
        font-family: 'Spectral', serif; 
        font-weight: 700;
        font-size:24px;
        line-height:32px;
    }
    blockquote p:before {
        content: '«';
        padding-right:5px;
    }
    blockquote p:after {
        content: '»';
        padding-left:5px;
    }
    ul {
        padding-left:20px;
        margin-bottom:15px;
    }
    ul li {
        font-size:16px;
        margin-bottom:10px;
        list-style: none;
        position:relative;
    }
    ul li:before {
        content: '';
        display: block;
        width:8px;
        height:8px;
        position:absolute;
        left: -20px;
        top: 10px;
        background: #006CEF;
        border-radius: 8px;
    }
    ol {
        padding-left:20px;
        margin-bottom:15px;
    }
    ol li {
        font-size:16px;
        margin-bottom:10px;
        list-style: decimal;
    }
    a {
        color: #002857;
        text-decoration:none;
        border-bottom: 1px solid #006CEF;
    }
    a:hover {
        color: #006CEF;
        text-decoration: none;
    }
    img.alignleft {
        float:left;
        margin: 0 20px 20px 0;
    }
    img.alignright {
        float:right;
        margin: 0 0 20px 20px;
    }
    img.aligncenter {
        margin: 0 auto 20px;
    }
    .excerpt p {
        font-family: 'Roboto', sans-serif; 
        font-weight: 400;
        font-size: 32px;
        line-height: 42px;
        margin-bottom: 15px;
    }
    .button a {
        height:48px;
        display: inline-flex;
        align-items:center;
        padding:0 30px;
        border: 2px solid #FF4136;
        font-size:18px;
        transition: all .1s ease-in-out;
    }
    .button a:hover {
        color: #002857!important;
        border: 2px solid #FF4136;
        background: #FF4136;
    }
    .topic {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        padding: 15px 0;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${css.colors.blue};
        cursor: pointer;
        font-size: 16px;

        > div {
            flex: 0 0 90%;
        }

        .arrow {
            position: relative;
            flex: 0 0 15px;
            height: 15px;
            width: 15px;

            &.open {
                &::before {
                    transform: rotate(45deg);
                }
                &::after {
                    transform: rotate(-45deg);
                }
            }

            &::before, &::after {
                position: absolute;
                bottom: 0px;
                width: 0.15rem;
                height: 100%;
                transition: all 0.5s;
                content: "";
            }

            &::before {
                left: -5px;
                transform: rotate(-45deg);
                background-color: #000000;
            }

            &::after {
                left: 5px;
                transform: rotate(45deg);
                background-color: #000000;
            }
        }
    
        @media (max-width: 768px) {
            width: 100%;
        }
    }

    .content {
        padding-top: 15px;
        display: none;

        &.expanded {
            display: block;
            overflow: scroll;
            height: 500px;
        }
    }
`

const StyledButton = styled(Button)`
    height: auto;
    min-height: 60px;
    width: 100%;
    margin-top: 40px;
`;

class Terms extends Component {
    constructor() {
        super();

        this.state = {
            accepted: false,
            visible: true,
            expandedItem: null,
            errors: {
                consent: ''
            },
        }
    }

    componentDidMount() {
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': 'Checkout - Vilkår',
            'pageURI': '/checkout/vilkar', 
        });
    }

    _handleAccepted = () => {
        this.setState({ accepted: !this.state.accepted });
        this.setState({ errors: { ...this.state.errors, consent: '' } });
        this.props.setTermsVisibility(false);
        this.props.setTermsAccepted(true);
    }

    _expandAccordion(topicTitle) {
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $('#terms-and-conditions-' + topicTitle).offset().top
            }, 300);
        }, 100);

        this.setState({
            expandedItem: this.state.expandedItem === topicTitle ? null : topicTitle
        });
    }

    _onSubmit() {
        if (!this.state.accepted) {
            this.setState({ errors: { ...this.state.errors, consent: msg('fieldRequired') } });

            return false;
        }

        return new Promise(resolve => { resolve(true); });
    }

    _onHandleClose()
    {
        this.props.resetCheckout();
        this.props.resetCheckoutCustomer();
        this.props.resetCheckoutOpportunity();
        this.props.setCheckoutVisibility(false);
    }

    render() {
        const { accepted, errors, visible } = this.state;
        const { termsVisible } = this.props.checkout;

        return (
            <Wrapper visible={termsVisible}>
                <Title>Vilkår og betingelser</Title>
                <CloseButton onClick={() => this.props.setTermsVisibility(false)}>
                    <CloseIcon color="#000000" />
                </CloseButton>
                <TermsText>
                    {WP.options.terms_and_conditions_topics.map(item => {
                        const key = safeCssClass(item.terms_and_conditions_topic_title);
                        const isExpanded = this.state.expandedItem === key;

                        return (
                            <React.Fragment key={'terms-and-conditions-' + key }>
                                <div id={'terms-and-conditions-' + key }>
                                    <div className="topic" onClick={e => this._expandAccordion(key)}>
                                        <div dangerouslySetInnerHTML={{ __html: item.terms_and_conditions_topic_title }} />
                                        <div className={isExpanded ? 'open arrow' : 'arrow'}></div>
                                    </div>
                                    <div className={isExpanded ? 'expanded content' : 'content'} dangerouslySetInnerHTML={{ __html: item.terms_and_conditions_topic_content }} />
                                </div>
                            </React.Fragment>
                        )
                    })}
                    <StyledButton main onClick={this._handleAccepted.bind(this)} error={errors.consent}>Jeg har lest og aksepterer Bjørknes’ vilkår og betingelser</StyledButton>
                </TermsText>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
    checkout: state.checkout,
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
    setCheckoutVisibility,
    setTermsVisibility,
    setTermsAccepted
}

export default connect(mapStateToProps, actions)(Terms);


// WEBPACK FOOTER //
// ./src/partials/Checkout/Terms.js